"use client";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import AppRoutes from "@/app/constants/routes";
import Image from "next/image";
import { useRouter } from "next/navigation";

function ErrorPage() {
  const { getImagePath } = useClientConfigProvider();
  const router = useRouter();
  return (
    <div className="section_landing_container max-width-for-larger-devices">
      <div
        className="section_hero"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "100vh",
        }}
      >
        <>
          <div className="error-page">
            <div>
              <Image
                src={"/common-images/error-corner-top.png"}
                alt=""
                width="80"
                height="100"
                className="error-side-corner-images"
              />
            </div>
            <div>
              <Image
                src={"/common-images/error-corner-bottom.png"}
                alt=""
                width="80"
                height="100"
                className="error-side-corner-bottom-images"
              />
            </div>
            <div>
              <div className="error-display-inner-content">
                <div className="page-not-found-text">404</div>
                <div className="page-not-found-text">NOT FOUND</div>
                <div
                  className="btn_back_login c-pointer"
                  onClick={() => {
                    router.push(AppRoutes.dashboard);
                  }}
                >
                  <div className="btn-icon">
                    <Image
                      src={"/common-images/home-icon.png"}
                      alt=""
                      width="18"
                      height="18"
                    />
                  </div>
                  <button className="">Back to Home</button>
                </div>
                <div>
                  <Image
                    src={"/common-images/error-logo.svg"}
                    alt=""
                    width="600"
                    height="200"
                    className="error-image"
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="wave_image_container">
                <div className="wave_image">
                  <Image
                    src={"/common-images/dashboard-wave-img.png"}
                    alt=""
                    width="1600"
                    height="213"
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </div>
              <div style={{ background: "white", height: "50px" }}></div>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export default ErrorPage;
